import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { orderBy } from 'natural-orderby';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { NavLink, withRouter } from 'react-router-dom';
import Modal from '../../../../../components/Modal';
import LayoutContext from '../../../../../store/Layout/contexts';

import { GET, POST, PUT, newFetch } from '../../../../../helpers/fetch';

import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config/index';
import { to12Hr, toWeekDaysArrayFull } from '../../../../../helpers/moment';

const { API_URL } = config;

const filterApproversBySites = (users, siteIds) => {
  const selectedSiteIds = new Set(siteIds.filter(Boolean).map(Number));

  return users.filter((user) => {
    const isSiteRestricted =
      user.type === 'client' || Number(user.is_ops) === 1;

    if (!isSiteRestricted) return true;

    return user.client_admins?.some((adminClient) =>
      adminClient.sites?.some((site) =>
        selectedSiteIds.has(Number(site.site_id))
      )
    );
  });
};

const AddAssociate = ({ history }) => {
  const token = localStorage.getItem('token');

  const [clients, setClients] = useState([]);
  const [activeClient, setActiveClient] = useState();
  const [sites, setSites] = useState([]);
  const [activeSites, setActiveSites] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [activeShifts, setActiveShifts] = useState([]);
  const [siteAssociates, setSiteAssociates] = useState([]);
  const [fixedSchedules, setFixedSchedules] = useState([]);
  const [claimApprovers, setClaimApprovers] = useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState({});
  const [associateList, setAssociateList] = useState({});
  const [clientUsers, setClientUsers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [adminsList, setAdminsList] = useState([]);
  const [modalMode, setModalMode] = useState('add');
  const [leaveSummaryId, setLeaveSummaryId] = useState();
  const [filteredLeaveTypes, setFilteredLeaveTypes] = useState([]);
  const [selectedLeaveApprovers, setSelectedLeaveApprovers] = useState({});
  const [bhCandID, setBHCandID] = useState('');
  const [pbJOID, setPBJOID] = useState('');
  const [pbCandID, setPBCandID] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [employeeNo, setEmployeeNo] = useState('');
  const [employeeID, setEmployeeID] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [email, setEmail] = useState('');
  const [positionList, setPositionList] = useState([]);
  const [leaveApprovers, setLeaveApprovers] = useState([]);
  const [data, setData] = React.useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [loadingLeave, setLoadingLeave] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [showLeaveSummaryModal, setShowLeaveSummaryModal] = useState(false);
  const [leaveTypeName, setLeaveTypeName] = useState([]);
  //Leave Summary Form
  const [leaveTypeId, setLeaveTypeId] = useState('');
  const [maxLeaves, setMaxLeaves] = useState('');
  const [available, setAvailable] = useState('');
  const [taken, setTaken] = useState(0); // Usually from DB
  const [activeDate, setActiveDate] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [sortModel, setSortModel] = useState([
    { field: 'updatedAt', sort: 'desc' },
  ]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [multipleRoles, setMultipleRoles] = useState([
    {
      id: null,
      pb_jo_no: '',
      role: '',
      is_disabled: false,
      is_deleted: false,
    },
  ]);
  const [position, setPosition] = useState('');
  const [teamList, setTeamList] = useState([]);
  const [team, setTeam] = useState('');
  const [department, setDepartment] = useState('');
  const [departmentList, setDepartmentList] = useState([]);
  const [team_lead_id, setTeamLeadID] = useState('');
  const [language, setLanguage] = useState('');
  const [isDisplayLastNameFirst, setIsDisplayLastNameFirst] = useState(false);
  const [claimCreditLimitPercentage, setClaimCreditLimitPercentage] = useState(
    []
  );
  const [clientSettings, setClientSettings] = useState([]);
  const bhCandIDHandler = (e) => setBHCandID(e.target.value);
  const pbJOIDHandler = (e) => setPBJOID(e.target.value);
  const firstNameHandler = (e) => setFirstName(e.target.value);
  const lastNameHandler = (e) => setLastName(e.target.value);
  const employeeNoHandler = (e) => setEmployeeNo(e.target.value);
  const employeeIDHandler = (e) => setEmployeeID(e.target.value);
  const dateOfBirthHandler = (e) => setDateOfBirth(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);
  const positionHandler = (e, index) => {
    multipleRoles[index].role = e.target.value;
    setMultipleRoles([...multipleRoles]);
    setPosition(e.target.value);
  };
  const positionPBJONOHandler = (e, index) => {
    const value = e.target.value.replace(/\D/g, '');
    multipleRoles[index].pb_jo_no = value;
    setMultipleRoles([...multipleRoles]);
  };
  const TeamHandler = (e) => setTeam(e.target.value);
  const DepartmentHandler = (e) => setDepartment(e.target.value);
  const TeamLeadIDHandler = (e) => setTeamLeadID(e.target.value);
  const displayLastNameHandler = (e) =>
    setIsDisplayLastNameFirst(e.target.checked);
  const languageHandler = (e) => setLanguage(e.target.value);
  const [validated, setValidated] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [restDays, setRestDays] = useState(['Sat', 'Sun']);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const monthName = months[new Date().getMonth()];
  const [monthValue, setMonthValue] = useState(monthName);
  const [showUpdateDatesModal, setShowUpdateDatesModal] = useState(false);
  const [bulkActiveFrom, setBulkActiveFrom] = useState('');
  const [bulkActiveTo, setBulkActiveTo] = useState('');

  const leaveColumns = [
    {
      field: 'leave_type.leave_name',
      headerName: 'Leave Type',
      flex: 2,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span
          className="leave-link"
          onClick={() => handleLeaveTypeClick(params.row)}
        >
          {params.row.leave_type?.leave_name || '--'}
        </span>
      ),
    },
    {
      field: 'max_leaves',
      headerName: 'Max Per Year',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.max_leaves ?? '--'}
        </span>
      ),
    },
    {
      field: 'available',
      headerName: 'Available',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.available ?? '--'}
        </span>
      ),
    },
    {
      field: 'taken',
      headerName: 'Taken',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.taken ?? '--'}
        </span>
      ),
    },
    {
      field: 'pending',
      headerName: 'Pending for Approval',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.pending ?? '--'}
        </span>
      ),
    },
    {
      field: 'active_date',
      headerName: 'Active From',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.active_date
            ? moment(params.row.active_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '--'}
        </span>
      ),
    },
    {
      field: 'expiry_date',
      headerName: 'Active To',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.expiry_date
            ? moment(params.row.expiry_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '--'}
        </span>
      ),
    },
  ];

  const clientHandler = (e) => {
    setActiveClient(
      [...clients].find((client) => client.id === parseInt(e.target.value))
    );
    setActiveSites(
      [...sites].filter((site) => site.client_id === parseInt(e.target.value))
    );
    setSiteAssociates([]);
  };

  const siteHandler = (e) => {
    if (e.target.value !== '') {
      const pickedSite = JSON.parse(e.target.value);
      if (
        !siteAssociates.some(
          (siteAssociate) => siteAssociate.site_id === parseInt(pickedSite.id)
        )
      ) {
        addSiteAssociate(pickedSite.id, pickedSite.name);
        setActiveShifts(
          [...shifts].filter((shift) => shift.site_id === pickedSite.id)
        );
      }
    }
  };

  const handleCloseLeaveSummaryModal = () => {
    setShowLeaveSummaryModal(false);
  };

  const handleLeaveTypeClick = (row) => {
    setModalMode('edit');
    fetchLeaveDetails(row); // pass the whole row
    setShowLeaveSummaryModal(true);
  };

  const handleBulkUpdateDates = () => {
    if (!bulkActiveFrom || !bulkActiveTo) {
      ToastUtil.error('Please select both dates.');
      return;
    }

    if (new Date(bulkActiveFrom) > new Date(bulkActiveTo)) {
      ToastUtil.error('Active From date must be before Active To date.');
      return;
    }

    setData((prevData) =>
      prevData.map((row) => ({
        ...row,
        active_date: bulkActiveFrom,
        expiry_date: bulkActiveTo,
      }))
    );

    ToastUtil.success('All active dates updated.');
    setShowUpdateDatesModal(false);
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  };

  const fetchLeaveDetails = (leaveRecord) => {
    if (!leaveRecord) {
      console.warn('No leave record passed');
      return;
    }

    setLeaveSummaryId(leaveRecord.id || '');
    setLeaveTypeName(leaveRecord.leave_type?.leave_name || '');
    setLeaveTypeId(leaveRecord.leave_type_id || '');
    setMaxLeaves(leaveRecord.max_leaves || '');
    setAvailable(leaveRecord.available || '');
    setActiveDate(
      leaveRecord.active_date ? formatDateForInput(leaveRecord.active_date) : ''
    );
    setExpiryDate(
      leaveRecord.expiry_date ? formatDateForInput(leaveRecord.expiry_date) : ''
    );
    setTaken(leaveRecord.taken ?? '0');
  };

  const handleLeaveApproverChange = (clientApprovalId, sourceId) => {
    setSelectedLeaveApprovers((prev) => ({
      ...prev,
      [clientApprovalId]: {
        client_approval_id: clientApprovalId,
        source_id: sourceId,
      },
    }));
  };

  const handleRestDayChange = (day, e) => {
    if (e.target.checked) {
      setRestDays([...restDays, day]);
    } else {
      setRestDays(restDays.filter((d) => d !== day));
    }
  };

  const handleLeaveSubmit = (e) => {
    e.preventDefault();
    saveLeaveSummary();
  };

  const saveLeaveSummary = () => {
    // Validation
    if (!leaveTypeId || !activeDate || !expiryDate) {
      ToastUtil.error('Please fill in all required fields.');
      return;
    }

    if (new Date(activeDate) > new Date(expiryDate)) {
      ToastUtil.error('Active From date must be before Active To date.');
      return;
    }

    if (maxLeaves < 0 || available < 0) {
      ToastUtil.error('Leave values cannot be negative.');
      return;
    }

    if (parseFloat(available) > parseFloat(maxLeaves)) {
      ToastUtil.error('Available leaves cannot exceed maximum leaves.');
      return;
    }

    const isEditMode = modalMode === 'edit';

    // Build new record
    const newRecord = {
      id: isEditMode ? leaveSummaryId : `temp-${Date.now()}`, // generate temp ID if add
      associate_id: 0 || null,
      leave_type_id: parseInt(leaveTypeId),
      leave_type: {
        leave_name: isEditMode
          ? leaveTypeName
          : filteredLeaveTypes.find((l) => l.id === parseInt(leaveTypeId))
              ?.name || '',
      },
      max_leaves: parseFloat(maxLeaves) || 0,
      available: parseFloat(available) || 0,
      taken: parseFloat(taken) || 0,
      pending: 0,
      active_date: activeDate,
      expiry_date: expiryDate,
    };

    // Update data state
    setData((prevData) => {
      if (isEditMode) {
        return prevData.map((item) =>
          item.id === leaveSummaryId ? { ...item, ...newRecord } : item
        );
      } else {
        return [...prevData, newRecord];
      }
    });

    // Show success message
    ToastUtil.success(isEditMode ? 'Leave type updated.' : 'Leave type added.');

    // Reset form in add mode
    if (!isEditMode) {
      setLeaveTypeId('');
      setMaxLeaves('');
      setAvailable('');
      setActiveDate('');
      setExpiryDate('');
      setTaken('');
    }

    // Close modal
    setShowLeaveSummaryModal(false);
  };

  const getSiteNameById = (id) => {
    const siteConst = sites.find((site) => site.id === id);
    return siteConst.name;
  };

  const addFixedSchedule = (day, shift_id, site_id) =>
    setFixedSchedules([
      ...fixedSchedules,
      {
        day,
        shift_id,
        site_id,
      },
    ]);

  const removeFixedSchedule = (day, shift_id, site_id) => {
    setFixedSchedules(
      [...JSON.parse(JSON.stringify(fixedSchedules))].filter(
        (fs) =>
          !(
            fs.day === day &&
            fs.shift_id === shift_id &&
            fs.site_id === site_id
          )
      )
    );
  };

  const claimCreditLimitPercentageHandler = (event, type, siteId) => {
    const value = event.target.value;

    setClaimCreditLimitPercentage((prevState) => {
      const existing = prevState.find((item) => item.site === siteId);

      if (existing) {
        return prevState.map((item) =>
          item.site === siteId
            ? {
                ...item,
                creditLimit:
                  type === 'credit limit'
                    ? parseFloat(value)
                    : item.creditLimit,
                creditPercentage:
                  type === 'credit percentage'
                    ? parseFloat(value)
                    : item.creditPercentage,
                claimNoReceipts:
                  type === 'no of receipts'
                    ? parseFloat(value)
                    : item.claimNoReceipts,
                safetyShoesCreditLimit:
                  type === 'safety shoes credit limit'
                    ? parseFloat(value)
                    : item.safetyShoesCreditLimit,
              }
            : item
        );
      } else {
        return [
          ...prevState,
          {
            site: siteId,
            creditLimit: type === 'credit limit' ? parseFloat(value) : '',
            creditPercentage:
              type === 'credit percentage' ? parseFloat(value) : '',
            claimNoReceipts: type === 'no of receipts' ? parseFloat(value) : '',
            safetyShoesCreditLimit:
              type === 'safety shoes credit limit' ? parseFloat(value) : '',
          },
        ];
      }
    });
  };

  const fixedScheduleCheckboxHandler = (day, shift_id, site_id, e) => {
    // check if is team support for site
    const siteAssociateArr = [...siteAssociates];
    const site = siteAssociateArr.find((site) => site.site_id === site_id);
    if (e.target.checked) {
      if (site.is_team_support === true) {
        addFixedSchedule(day, shift_id, site_id);
      } else {
        e.preventDefault();
        e.stopPropagation();
        ToastUtil.error('Please set employee as team support for this site.');
      }
    } else {
      removeFixedSchedule(day, shift_id, site_id);
    }
  };

  const handleAddNewLeaveType = async (e) => {
    e.preventDefault();
    setLeaveTypeId('');
    setMaxLeaves('');
    setAvailable('');
    setActiveDate('');
    setExpiryDate('');
    setTaken('');

    setModalMode('add');
    setShowLeaveSummaryModal(true);
  };

  const startDateHandler = (index, e) => {
    let siteAssociatesArr = [...siteAssociates];
    siteAssociatesArr[index].start_date = e.target.value;
    setSiteAssociates(siteAssociatesArr);
  };

  const resignDateHandler = (index, e) => {
    let siteAssociatesArr = [...siteAssociates];
    siteAssociatesArr[index].resign_date = e.target.value;
    setSiteAssociates(siteAssociatesArr);
  };

  const lastDayDateHandler = (index, e) => {
    let siteAssociatesArr = [...siteAssociates];
    siteAssociatesArr[index].last_day_date = e.target.value;
    setSiteAssociates(siteAssociatesArr);
  };

  const teamSupportHandler = (index, e) => {
    const siteAssociatesArr = [...siteAssociates];
    siteAssociatesArr[index].is_team_support = e.target.checked;
    setSiteAssociates(siteAssociatesArr);
  };

  const regrettableHandler = (index, e) => {
    const siteAssociatesArr = [...siteAssociates];
    siteAssociatesArr[index].is_regrettable = e.target.checked;
    setSiteAssociates(siteAssociatesArr);
  };

  const blueBadgeHandler = (index, e) => {
    const siteAssociatesArr = [...siteAssociates];
    siteAssociatesArr[index].is_blue_badge = e.target.checked;
    setSiteAssociates(siteAssociatesArr);
  };

  const contractHandler = (index, e) => {
    const siteAssociatesArr = [...siteAssociates];
    siteAssociatesArr[index].is_contract = e.target.checked;
    setSiteAssociates(siteAssociatesArr);
  };

  const addSiteAssociate = (id, name) =>
    setSiteAssociates([
      ...siteAssociates,
      {
        name,
        site_id: id,
        is_team_support: false,
        start_date: '',
        resign_date: '',
        last_day_date: '',
        is_contract: false,
        is_blue_badge: false,
        is_regrettable: false,
      },
    ]);

  const removeSiteAssociate = (index) => {
    setSiteAssociates(
      [...siteAssociates].filter((siteAssociate, i) => i !== index)
    );
  };

  const addMoreRoles = () => {
    multipleRoles.push({
      id: null,
      pb_jo_no: '',
      role: '',
      is_disabled: false,
      is_deleted: false,
    });
    setMultipleRoles([...multipleRoles]);
  };

  const removeRoles = (index) => {
    multipleRoles[index].is_deleted = true;
    setMultipleRoles([...multipleRoles]);
  };

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setFirstName('');
      setLastName('');
      setEmployeeNo('');
      setEmployeeID('');
      setDateOfBirth('');
      setEmail('');
      setActiveClient(null);
      setActiveSites([]);
      setFixedSchedules([]);
      setPosition('');
      setTeam('');
      setDepartment('');
      setTeamLeadID('');
      setLanguage('');
      setIsDisplayLastNameFirst(false);
    }
  };

  const fetchLeave = async (newPaginationModel, newSortModel) => {
    try {
      setLoadingLeave(true);

      // Use the provided models or fall back to current state
      const currentPaginationModel = newPaginationModel || paginationModel;
      const currentSortModel = newSortModel || sortModel;

      // Default sorting if no sort model is provided
      const sortField =
        currentSortModel.length > 0
          ? currentSortModel[0].field
          : 'leave_type.leave_name';
      const sortDirection =
        currentSortModel.length > 0 ? currentSortModel[0].sort : 'asc';

      // API path for default template (no associate_id yet)
      const api_path = `/leave-types/template`;
      const response = await newFetch(POST, api_path, {
        field: sortField,
        sort: sortDirection,
        page: currentPaginationModel.page,
        pageSize: currentPaginationModel.pageSize,
      });

      if (response.success) {
        setLeaveList(response.data.list);
        setTotalRows(response.data.total_record);
      } else {
        setLeaveList([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error('Error fetching leave template:', error);
      setLeaveList([]);
      setTotalRows(0);
    } finally {
      setLoadingLeave(false);
    }
  };

  const fetchAssociateListBySiteID = async (site_id) => {
    let api_path = `/associate/site/${site_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let associatesData = response.data;
      let sorted = orderBy(associatesData, [
        (associate) => `${associate.first_name} ${associate.last_name}`,
      ]);
      setAssociateList(sorted);
    }
  };

  const fetchLeaveApprovers = async (client_id) => {
    const fetch_path = `/client/${client_id}/leaveapprovers`;

    if (!token) {
      console.log('Token is missing');
      return;
    }

    try {
      const response = await newFetch(GET, fetch_path);

      if (response.success) {
        const approvers = response.data.map((item, index) => ({
          id: item.id,
          value: item.type, // Using item.type as value
        }));

        setLeaveApprovers(approvers);
      } else {
        console.log('Error:', response.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const fetchAllLeaveType = async () => {
    const fetch_path = `/leave-types/all`;

    if (!token) {
      console.log('Token is missing');
      return;
    }

    try {
      const response = await newFetch(GET, fetch_path);

      if (response.success) {
        // get the existing leave_type_id from data
        const existingIds = new Set(data.map((item) => item.leave_type_id));

        // filter leave types not already in data
        const filtered = response.data.filter(
          (item) => !existingIds.has(item.leave_type_id)
        );

        // map into approver format
        const filteredLeaveTypes = filtered.map((item) => ({
          id: item.leave_type_id, // correct id field
          name: item.leave_name, // use leave_name instead of "type"
        }));

        setFilteredLeaveTypes(filteredLeaveTypes);
      } else {
        console.log('Error:', response.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const CreateRestDays = async (associate_id) => {
    let api_path = `/associate/${associate_id}/create-rest-days`;

    const payload = restDays;

    try {
      return await newFetch(POST, api_path, payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const CreateLeaveSummary = async (associate_id) => {
    let api_path = `/associate-leave-summary/insert/${associate_id}`;

    const payload = data;

    try {
      return await newFetch(POST, api_path, payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const fetchClaimApprovers = async (site_id) => {
    if (!activeClient?.id) {
      console.log('Client ID is missing');
      return;
    }

    if (!token) {
      console.log('Token is missing');
      return;
    }

    const url = `${API_URL}/client/${activeClient.id}/site/${site_id}/claimapprovers`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();

        if (data.success) {
          const approvers = data.data.map((item) => ({
            name: item.site.name,
            id: item.id,
            value: item.type,
            site_id: item.site_id,
          }));

          return approvers;
        } else {
          console.log('Error:', data.message);
          return [];
        }
      } else {
        console.log('HTTP Error:', response.statusText);
        return [];
      }
    } catch (error) {
      console.error('Fetch error:', error);
      return [];
    }
  };

  const UpdateApprover = async (type, associate_id) => {
    let api_path = `/associate/${associate_id}/create-update-associateapprover/type/${type}`;

    let payload;
    if (type === 'claims') {
      payload = selectedApprovers;
    } else if (type === 'leaves') {
      payload = selectedLeaveApprovers;
    } else {
      throw new Error('Invalid approver type');
    }

    try {
      return await newFetch(PUT, api_path, payload);
    } catch (error) {
      console.log(error);
    }
  };

  async function fetchData() {
    try {
      const fetchPosition = fetch(`${API_URL}/fields/position`, {
        method: 'GET',
        withCredentials: false,
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      });

      const fetchTeam = fetch(`${API_URL}/fields/team`, {
        method: 'GET',
        withCredentials: false,
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      });

      const response = await Promise.all([fetchPosition, fetchTeam]);

      const data = await Promise.all(response.map((res) => res.json()));
      setPositionList(data[0].data);
      setTeamList(data[1].data);
    } catch (err) {
      console.log(err);
    }
  }

  const fetchClients = async () => {
    try {
      let api_path = `/client`;

      let response = await newFetch(GET, api_path);

      response.success
        ? setClients(response.data)
        : ToastUtil.error(response.message);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSites = async () => {
    try {
      let api_path = `/sites`;
      let response = await newFetch(GET, api_path);

      response.success
        ? setSites(response.data)
        : ToastUtil.error(response.message);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchShifts = async () => {
    try {
      let api_path = `/shifts`;
      let response = await newFetch(GET, api_path);

      response.success
        ? setShifts(response.data)
        : ToastUtil.error(response.message);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDepartments = async (client_id) => {
    try {
      let api_path = `/lu_fields/type/department/client/${client_id}`;
      let response = await newFetch(GET, api_path);

      response.success
        ? setDepartmentList(response.data)
        : ToastUtil.error(response.message);
    } catch (error) {
      console.log(error);
    }
  };

  const submitAssociate = async () => {
    let data = {
      first_name: firstName,
      last_name: lastName,
      employee_id: employeeID,
      employee_no: employeeNo,
      date_of_birth: dateOfBirth,
      email,
      bh_cand_id: bhCandID,
      pb_jo_id: pbJOID,
      pb_cand_id: pbCandID,
      position: position,
      team: team,
      department: department,
      team_lead_id: team_lead_id,
      language,
      last_name_first: isDisplayLastNameFirst ? 1 : 0,
      multipleRoles: multipleRoles,
    };

    let api_path = `/associate/create`;
    let response = await newFetch(POST, api_path, data);

    return response;
  };

  const submitSiteAssociate = async (id) => {
    try {
      let api_path = `/associate/${id}/assignsite`;
      let data = {
        sites: [...siteAssociates].map((siteAssociate) => ({
          ...siteAssociate,
          last_day_date: siteAssociate.last_day_date
            ? siteAssociate.last_day_date
            : null,
          resign_date: siteAssociate.resign_date
            ? siteAssociate.resign_date
            : null,
          start_date: siteAssociate.start_date
            ? siteAssociate.start_date
            : null,
        })),
        claims: claimCreditLimitPercentage,
      };

      let response = await newFetch(POST, api_path, data);
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const submitFixedSchedule = async (id) => {
    try {
      let api_path = `/associate/${id}/fixed_schedule`;
      const results = [];

      for (const fs of fixedSchedules) {
        const res = await newFetch(POST, api_path, fs);
        results.push(res);
      }

      return results;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const pbCandIDNumOnlyHandler = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setPBCandID(value);
  };

  const pbJOIDNumOnlyHandler = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setPBJOID(value);
  };

  const bhCandIDNumOnlyHandler = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setBHCandID(value);
  };

  const submitAssociateHandler = async (e) => {
    e.preventDefault();

    if (fixedSchedules) {
      // 1. Check if any team support site has no fixed schedule
      const notFilled = siteAssociates
        .filter((site) => site.is_team_support)
        .filter((site) => {
          return !fixedSchedules.some((fs) => fs.site_id === site.site_id);
        });

      if (notFilled.length > 0) {
        const siteNames = notFilled
          .map((site) => getSiteNameById(site.site_id))
          .join(', ');
        ToastUtil.error(
          `Please select at least one fixed schedule for these sites: ${siteNames}.`
        );
        return false;
      }

      // 2. Validate that all fixed schedules for the same site have the same shift_id
      const siteShiftMap = {};
      for (const sched of fixedSchedules) {
        if (!siteShiftMap[sched.site_id]) {
          siteShiftMap[sched.site_id] = sched.shift_id;
        } else if (siteShiftMap[sched.site_id] !== sched.shift_id) {
          const siteName = getSiteNameById(sched.site_id);
          ToastUtil.error(
            `All fixed schedules for site ${siteName} must have the same shift.`
          );
          return false;
        }
      }
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to add this employee?'
      )
    ) {
      let submit_associate_response = await submitAssociate();

      if (!submit_associate_response.success) {
        ToastUtil.error(submit_associate_response.message);
        return false;
      }

      let associate_id = submit_associate_response.data.associate_id;

      let submit_site_associates_response = await submitSiteAssociate(
        associate_id
      );

      if (!submit_site_associates_response.success) {
        ToastUtil.error(
          'Employee created successfully but failed to assign Employee to Site.'
        );
        history.push('/associates');
      }

      let submit_fixed_schedules_response = await submitFixedSchedule(
        associate_id
      );

      if (
        submit_fixed_schedules_response.find((response) => !response.success)
      ) {
        ToastUtil.error(
          'Employee created successfully but failed to assign some Fixed Schedules.'
        );
        history.push('/associates');
      }

      if (selectedApprovers) await UpdateApprover('claims', associate_id);
      if (selectedLeaveApprovers) await UpdateApprover('leaves', associate_id);

      await CreateLeaveSummary(associate_id);
      await CreateRestDays(associate_id);

      ToastUtil.success(submit_associate_response.message);
      history.push('/associates');
    }
  };

  const fetchAdmins = async () => {
    let api_path = `/admin/admins`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let filtered = response.data.filter((admin) => admin.is_super != true);
      setAdminsList(filtered);
    }
  };

  const fetchClientUsers = async () => {
    if (!activeClient?.id) {
      console.error('Error: activeClient.id is missing or invalid.');
      return;
    }

    let url = `${API_URL}/client/users/client_users/${activeClient.id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setClientUsers(data.data);
      }
    } catch (error) {
      console.error('Error fetching client users:', error);
      ToastUtil.error('An error occurred while fetching client users.');
    }
  };

  const fetchAdminsByClient = async () => {
    if (!activeClient?.id) {
      console.error('Error: activeClient.id is missing or invalid.');
      return;
    }

    let url = `${API_URL}/admin/client/${activeClient.id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setAdmins(data.data);
      }
    } catch (error) {
      console.error('Error fetching admins:', error);
    }
  };

  const init = async () => {
    await fetchClients();
    await fetchSites();
    await fetchShifts();
    await fetchData();
    await fetchDepartments(0);
    await fetchAdmins();
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      ToastUtil.error('Please fill out the required fields.');
    } else {
      await submitAssociateHandler(event);
    }

    setValidated(true);
  };

  const fetchSiteSettings = async (siteID) => {
    const api_path = `/dashboard/site_settings/site/${siteID}`;
    const response = await newFetch(GET, api_path);
    if (response.success) {
      return response?.data;
    }
  };

  const handleApproverChange = (siteApprovalId, sourceId) => {
    setSelectedApprovers((prev) => ({
      ...prev,
      [siteApprovalId]: {
        site_approval_id: siteApprovalId,
        source_id: sourceId,
      },
    }));
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    fetchAllLeaveType();
  }, [data]);

  useEffect(() => {
    const processedData =
      leaveList !== undefined
        ? leaveList.map((item) => ({
            ...item,
            id: item.leave_type_id || `temp-${Math.random()}`, // Fallback for safety
          }))
        : [];

    setData(processedData);
    leaveList !== undefined && setLoadingLeave(false);
  }, [leaveList]);

  useEffect(() => {
    const fetchAllClaimApprovers = async () => {
      if (siteAssociates && siteAssociates.length > 0) {
        // Get unique site IDs to prevent duplicate fetching
        const uniqueSiteIds = [
          ...new Set(siteAssociates.map((item) => item.site_id)),
        ];

        // Filter out any undefined or null site IDs
        const validSiteIds = uniqueSiteIds.filter((id) => id);

        // Use Promise.all to fetch data for all sites concurrently
        const allApproverArrays = await Promise.all(
          validSiteIds.map((siteId) => fetchClaimApprovers(siteId))
        );

        const allSiteSettingsArrays = await Promise.all(
          validSiteIds.map((siteId) => fetchSiteSettings(siteId))
        );

        // Flatten the array of arrays
        const allApprovers = allApproverArrays.flat();

        // Set the state with all approvers at once
        setClaimApprovers(allApprovers);
        setClientSettings(allSiteSettingsArrays);
      }
    };

    fetchAllClaimApprovers();
  }, [siteAssociates]);

  useEffect(() => {
    if (claimApprovers && claimApprovers.length > 0) {
      claimApprovers.forEach((approver) => {
        if (approver.value === 'associate' && approver.site_id) {
          fetchAssociateListBySiteID(approver.site_id);
        }
      });
      //fetchApprovers();
    }
  }, [claimApprovers]);

  useEffect(() => {
    if (activeClient) {
      fetchClientUsers();
      fetchAdminsByClient();
      fetchDepartments(activeClient.id);
      fetchLeaveApprovers(activeClient.id);
    }
  }, [activeClient]);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/associates`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i> Back to Employee
                Management
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Add Employee</h5>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '1rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  minWidth: '15rem',
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Employee Information</strong>
                <p className="pt-2 text-muted">
                  View and edit employee information
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Row className="mb-3">
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>BH Candidate ID</strong>
                    </Form.Label>
                    <Form.Control
                      value={bhCandID || ''}
                      name="bh_cand_id"
                      placeholder="BH Candidate ID"
                      onChange={bhCandIDNumOnlyHandler}
                      maxLength={10}
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>PB Candidate ID</strong>
                    </Form.Label>
                    <Form.Control
                      value={pbCandID || ''}
                      name="pb_cand_id"
                      placeholder="PB Candidate ID"
                      onChange={pbCandIDNumOnlyHandler}
                      maxLength={10}
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>First Name*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="firstName"
                      value={firstName || ''}
                      placeholder="First name"
                      onChange={(e) => firstNameHandler(e)}
                      maxLength={60}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter first name.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>Last Name*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      name="lastName"
                      value={lastName || ''}
                      type="text"
                      placeholder="Last name"
                      onChange={(e) => lastNameHandler(e)}
                      maxLength={60}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter last name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="6">
                    <Form.Check
                      type={`checkbox`}
                      name="isLastNameFirst"
                      id={`isLastNameFirst`}
                      style={{
                        marginLeft: 10,
                      }}
                    >
                      <Form.Check.Input
                        type={`checkbox`}
                        onChange={(e) => {
                          displayLastNameHandler(e);
                        }}
                        checked={isDisplayLastNameFirst}
                      />
                      <Form.Check.Label
                        style={{
                          marginLeft: 5,
                          fontWeight: 400,
                          fontStyle: 'italic',
                        }}
                      >{`Last Name First`}</Form.Check.Label>
                    </Form.Check>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Employee No</strong>
                    </Form.Label>
                    <Form.Control
                      name="employeeNo"
                      value={employeeNo || ''}
                      type="text"
                      placeholder="Employee No"
                      onChange={(e) => employeeNoHandler(e)}
                      maxLength={12}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter employee no.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Employee ID</strong>
                    </Form.Label>
                    <Form.Control
                      name="employeeID"
                      value={employeeID || ''}
                      type="text"
                      placeholder="Employee ID"
                      onChange={(e) => employeeIDHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter employee id.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12">
                    <strong>Date Of Birth*</strong>
                    <Form.Control
                      type="text"
                      name="dateOfBirth"
                      value={dateOfBirth || ''}
                      required
                      hidden
                      onChange={(e) => {
                        dateOfBirthHandler(e);
                      }}
                    />
                    <DatePicker
                      minDate={new Date(1900, 0, 1)}
                      maxDate={new Date()}
                      hideIfNoPrevNext={true}
                      defaultValue={new Date()}
                      dateFormat="dd MMMM yyyy"
                      renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                      }) => (
                        <div
                          style={{
                            margin: 10,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <select
                            aria-label="Birth year"
                            value={date.getFullYear()}
                            onChange={({ target: { value } }) =>
                              changeYear(Number(value))
                            }
                            className="me-2"
                          >
                            {Array.from(
                              { length: new Date().getFullYear() - 1900 + 1 },
                              (_, index) => new Date().getFullYear() - index,
                            ).map((year) => (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            ))}
                          </select>
                          <select
                            value={monthValue}
                            onChange={({ target: { value } }) => {
                              changeMonth(months.indexOf(value));
                              setMonthValue(value);
                            }}
                          >
                            {months.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        setDateOfBirth(date === null ? '' : date);
                      }}
                      className={`form-control `}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter date of birth.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-2">
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Email*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      name="email"
                      value={email || ''}
                      type="email"
                      placeholder="Email"
                      onChange={(e) => emailHandler(e)}
                      maxLength={100}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter valid email.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: siteAssociates.find(
                  (siteAssociate) => siteAssociate.is_team_support
                )
                  ? '0'
                  : '1rem',
              }}
            >
              <div
                style={{
                  minWidth: '15rem',
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Assigned To</strong>
                <p className="pt-2 text-muted">
                  Manage client and site assignation
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Row className="mb-3">
                  <Form.Group as={Col} md="12">
                    <strong>Client*</strong>
                    <Form.Control
                      as="select"
                      required
                      type="select"
                      onChange={(e) => clientHandler(e)}
                    >
                      <option value="">Select Client</option>
                      {clients &&
                        clients.map((client) => (
                          <option key={client.id} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a client.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <strong>Add Sites*</strong>
                    <Form.Control
                      as="select"
                      required
                      type="select"
                      onChange={(e) => siteHandler(e)}
                    >
                      <option value="">Select Site</option>
                      {activeSites &&
                        activeSites
                          .filter((site) => site.active === true)
                          .map((site) => (
                            <option key={site.id} value={JSON.stringify(site)}>
                              {site.name}
                            </option>
                          ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a site.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="col-sm-12">
                    {siteAssociates.map((siteAssociate, index) => (
                      <div key={index} className="pt-3">
                        <div className="d-flex justify-content-between">
                          <strong>{siteAssociate.name}</strong>
                          <p
                            style={{ cursor: 'pointer' }}
                            className="text-danger"
                            onClick={() => removeSiteAssociate(index)}
                          >
                            Remove
                          </p>
                        </div>
                        <div
                          className="border rounded mt-2"
                          style={{ padding: '2.25rem' }}
                        >
                          <Row>
                            <Form.Group as={Col} md="6">
                              <strong>Start Date*</strong>
                              <Form.Control
                                type="date"
                                value={siteAssociate.start_date}
                                onChange={(e) => startDateHandler(index, e)}
                                required
                              />
                              <Form.Control.Feedback type="invalid">
                                Please select start date.
                              </Form.Control.Feedback>
                            </Form.Group>
                            <div className="col-sm-6">
                              <strong>Fixed Shift?</strong>
                              <div className="pt-2">
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    onChange={(e) =>
                                      teamSupportHandler(index, e)
                                    }
                                    checked={siteAssociate.is_team_support}
                                  />
                                  <span className="slider round"></span>
                                </label>
                              </div>
                            </div>
                          </Row>
                          <Row>
                            <Form.Group as={Col} md="6">
                              <strong>Resign Date</strong>
                              <Form.Control
                                type="date"
                                value={siteAssociate.resign_date}
                                onChange={(e) => resignDateHandler(index, e)}
                              />
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                              <strong>Last Day Date</strong>
                              <Form.Control
                                type="date"
                                value={siteAssociate.last_day_date}
                                onChange={(e) => lastDayDateHandler(index, e)}
                              />
                            </Form.Group>
                          </Row>
                          {siteAssociate.last_day_date !== '' && (
                            <div className="row pt-4">
                              <div className="col-sm-4">
                                <strong>Regrettable?</strong>
                                <div className="pt-4">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      onChange={(e) =>
                                        regrettableHandler(index, e)
                                      }
                                      checked={siteAssociate.is_regrettable}
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="col-sm-4">
                                <strong>Contract?</strong>
                                <div className="pt-4">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      onChange={(e) =>
                                        contractHandler(index, e)
                                      }
                                      checked={siteAssociate.is_contract}
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="col-sm-4">
                                <strong>Blue Badge?</strong>
                                <div className="pt-4">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      onChange={(e) =>
                                        blueBadgeHandler(index, e)
                                      }
                                      checked={siteAssociate.is_blue_badge}
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </Row>
                <Row>
                  <Form.Group
                    as={Col}
                    md="4"
                    style={{
                      marginTop: 10,
                    }}
                  >
                    <strong>Team</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      onChange={(e) => TeamHandler(e)}
                      value={team}
                    >
                      <option value="">Select Team</option>
                      {teamList &&
                        teamList.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </Form.Control>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    md="4"
                    style={{
                      marginTop: 10,
                    }}
                  >
                    <strong>Department</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      onChange={(e) => DepartmentHandler(e)}
                      value={department}
                    >
                      <option value="">Select Department</option>
                      {departmentList &&
                        departmentList.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </Form.Control>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    md="4"
                    style={{
                      marginTop: 10,
                    }}
                  >
                    <strong>Team Lead</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      onChange={(e) => TeamLeadIDHandler(e)}
                      value={team_lead_id}
                    >
                      <option value="">Select Team Lead</option>
                      {filterApproversBySites(
                        [...admins, ...clientUsers],
                        siteAssociates.map((siteAssociate) => siteAssociate.site_id)
                      ).map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.first_name} {item.last_name}
                          </option>
                        ))}
                    </Form.Control>
                  </Form.Group>
                </Row>
              </div>
            </div>
            {siteAssociates.find(
              (siteAssociate) => siteAssociate.is_team_support
            ) && (
              <div
                className="border rounded d-flex"
                style={{
                  marginTop: '2rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                  marginBottom: '1rem',
                }}
              >
                <div
                  style={{
                    minWidth: '15rem',
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                  className="border-right"
                >
                  <strong>Fixed Schedule</strong>
                  <p className="pt-2 text-muted">
                    Manage fixed schedule for employees as Team Support
                  </p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  {activeClient && (
                    <div className="row">
                      <div className="col-sm-12">
                        <table className="table table-bordered">
                          <thead>
                            <th className="border-bottom-0"></th>
                            {toWeekDaysArrayFull(
                              moment(),
                              activeClient.start_day
                            ).map((day) => (
                              <th className="border-bottom-0">
                                {moment(day).format('ddd')}
                              </th>
                            ))}
                          </thead>
                          <tbody>
                            {siteAssociates.map(
                              (site) =>
                                site.is_team_support && (
                                  <React.Fragment>
                                    <tr>
                                      <td colspan="8">
                                        <b>{getSiteNameById(site.site_id)}</b>
                                      </td>
                                    </tr>
                                    {shifts &&
                                      shifts
                                        .sort((a, b) =>
                                          a.name > b.name ? 1 : -1
                                        )
                                        .filter(
                                          (shift) => shift.status === true
                                        )
                                        .map(
                                          (shift) =>
                                            shift.site_id === site.site_id && (
                                              <tr>
                                                <td
                                                  style={{
                                                    whiteSpace: 'nowrap',
                                                  }}
                                                >{`${shift.name} (${to12Hr(
                                                  shift.start_time
                                                )}-${to12Hr(
                                                  shift.end_time
                                                )})`}</td>
                                                {toWeekDaysArrayFull(
                                                  moment(),
                                                  activeClient.start_day
                                                ).map((day, index) => (
                                                  <td className="text-center">
                                                    <input
                                                      type="checkbox"
                                                      value={shift.id}
                                                      checked={fixedSchedules.some(
                                                        (schedule) =>
                                                          schedule.day ===
                                                            day.day() &&
                                                          schedule.shift_id ===
                                                            shift.id
                                                      )}
                                                      onClick={(e) =>
                                                        fixedScheduleCheckboxHandler(
                                                          day.day(),
                                                          shift.id,
                                                          site.site_id,
                                                          e
                                                        )
                                                      }
                                                      className="ms-1 form-check-input position-static"
                                                    />
                                                  </td>
                                                ))}
                                              </tr>
                                            )
                                        )}
                                  </React.Fragment>
                                )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {clients && siteAssociates && siteAssociates.length > 0 && (
              <div
                className="border rounded d-flex"
                style={{
                  marginTop: '2rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                  marginBottom: '1rem',
                }}
              >
                <div
                  style={{
                    minWidth: '15rem',
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                  className="border-right"
                >
                  <strong>Claims</strong>
                  <p className="pt-2 text-muted">
                    Assign limits, percentage and approvers of claims.
                  </p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <Card className="mb-4">
                    <CardHeader>
                      <strong>Settings</strong>
                    </CardHeader>
                    <CardBody>
                      {clientSettings.length > 0 &&
                        clientSettings.map((item, index) => {
                          const siteData = claimCreditLimitPercentage.find(
                            (s) => s.site === item.id
                          );

                          return (
                            <Row key={`${item.id}-${index}`} className="mb-4">
                              <strong className="fw-bold">{item.name}</strong>

                              {item?.enable_claim_limit && (
                                <Form.Group as={Col} md="4">
                                  <Form.Label>
                                    <strong className="text-muted">
                                      Credit Limit
                                    </strong>
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    name="credit_limit"
                                    value={siteData?.creditLimit || ''}
                                    type="text"
                                    placeholder="Credit Limit"
                                    onChange={(e) =>
                                      claimCreditLimitPercentageHandler(
                                        e,
                                        'credit limit',
                                        item.id
                                      )
                                    }
                                    maxLength={12}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter credit limit.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}

                              {item?.enable_claim_percentage && (
                                <Form.Group as={Col} md="4">
                                  <Form.Label>
                                    <strong className="text-muted">
                                      Credit Percentage (%)
                                    </strong>
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    name="credit_percentage"
                                    value={siteData?.creditPercentage || ''}
                                    type="text"
                                    placeholder="Credit Percentage"
                                    onChange={(e) =>
                                      claimCreditLimitPercentageHandler(
                                        e,
                                        'credit percentage',
                                        item.id
                                      )
                                    }
                                    maxLength={12}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter credit percentage.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}

                              {item?.enable_claim_receipt && (
                                <Form.Group as={Col} md="4">
                                  <Form.Label>
                                    <strong className="text-muted">
                                      No. of Claim Receipts
                                    </strong>
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    name="claim_no_receipts"
                                    value={siteData?.claimNoReceipts || ''}
                                    type="text"
                                    placeholder="No. of Claim Receipts"
                                    onChange={(e) =>
                                      claimCreditLimitPercentageHandler(
                                        e,
                                        'no of receipts',
                                        item.id
                                      )
                                    }
                                    maxLength={12}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter number of receipts.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}

                              {!item?.enable_claim_limit &&
                                !item?.enable_claim_percentage &&
                                !item?.enable_claim_receipt && (
                                  <p className="text-muted">
                                    Credit Limits, Percentage & Receipt Settings
                                    for Claims are disabled.
                                  </p>
                                )}
                            </Row>
                          );
                        })}
                    </CardBody>
                  </Card>

                  <Card className="mb-4">
                    <CardHeader>
                      <strong>Safety Shoes Settings</strong>
                    </CardHeader>
                    <CardBody>
                      {clientSettings.length > 0 &&
                        clientSettings.map((item, index) => {
                          const siteData = claimCreditLimitPercentage.find(
                            (s) => s.site === item.id
                          );

                          return (
                            <Row key={`${item.id}-${index}`} className="mb-4">
                              <strong className="fw-bold">{item.name}</strong>

                              {item?.enable_ss_claim_limit && (
                                <Form.Group as={Col} md="4">
                                  <Form.Label>
                                    <strong className="text-muted">
                                      Safety Shoes Credit Limit
                                    </strong>
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    name="ss_credit_limit"
                                    value={
                                      siteData?.safetyShoesCreditLimit || ''
                                    }
                                    type="text"
                                    placeholder="Safety Shoes Credit Limit"
                                    onChange={(e) =>
                                      claimCreditLimitPercentageHandler(
                                        e,
                                        'safety shoes credit limit',
                                        item.id
                                      )
                                    }
                                    maxLength={12}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter safety shoes credit limit.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}

                              {!item?.enable_ss_claim_limit && (
                                <p className="text-muted">
                                  Safety Shoes Credit Limits for Claims Settings
                                  are disabled.
                                </p>
                              )}
                            </Row>
                          );
                        })}
                    </CardBody>
                  </Card>

                  <Card className="mb-4">
                    <Card.Header>
                      <strong>Approvers</strong>
                    </Card.Header>
                    <Card.Body>
                      {claimApprovers && claimApprovers.length > 0 ? (
                        Object.entries(
                          claimApprovers.reduce((acc, approver) => {
                            acc[approver.name] = acc[approver.name] || [];
                            acc[approver.name].push(approver);
                            return acc;
                          }, {})
                        )
                          .sort(([siteNameA], [siteNameB]) =>
                            siteNameA.localeCompare(siteNameB)
                          ) // site names ASC
                          .map(([siteName, approvers]) => (
                            <div
                              key={siteName}
                              className="mb-4 p-3 border rounded col-md-8"
                            >
                              <h5 className="fw-bold">{siteName}</h5>
                              {approvers.map((approver, index) => (
                                <Row
                                  key={approver.id}
                                  className="align-items-center mb-2"
                                >
                                  <Col md={3} className="fw-bold">
                                    Approver {index + 1}
                                  </Col>
                                  <Col md={9}>
                                    <Form.Group
                                      controlId={`approver-${approver.id}`}
                                    >
                                      <Form.Label className="fw-semibold">
                                        {approver.value
                                          .charAt(0)
                                          .toUpperCase() +
                                          approver.value.slice(1)}{' '}
                                        *
                                      </Form.Label>
                                      <Form.Control
                                        as="select"
                                        required
                                        value={
                                          selectedApprovers[
                                            approver.id
                                          ]?.source_id?.toString() || ''
                                        }
                                        onChange={(e) =>
                                          handleApproverChange(
                                            approver.id,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">Select</option>

                                        {/* Client Users */}
                                        {approver.value === 'client' &&
                                          filterApproversBySites(
                                            clientUsers,
                                            [approver.site_id]
                                          )
                                            ?.slice()
                                            .sort((a, b) =>
                                              `${a.first_name} ${a.last_name}`.localeCompare(
                                                `${b.first_name} ${b.last_name}`
                                              )
                                            )
                                            .map((user) => (
                                              <option
                                                key={user.id}
                                                value={user.id}
                                              >
                                                {user.first_name}{' '}
                                                {user.last_name}
                                              </option>
                                            ))}

                                        {/* Associates */}
                                        {approver.value === 'associate' &&
                                          associateList
                                            ?.slice()
                                            .sort((a, b) =>
                                              `${a.first_name} ${a.last_name}`.localeCompare(
                                                `${b.first_name} ${b.last_name}`
                                              )
                                            )
                                            .map((associate) => (
                                              <option
                                                key={associate.id}
                                                value={associate.id}
                                              >
                                                {associate.first_name}{' '}
                                                {associate.last_name}
                                              </option>
                                            ))}

                                        {/* Admins */}
                                        {approver.value === 'admin' &&
                                          filterApproversBySites(admins, [
                                            approver.site_id,
                                          ])
                                            ?.slice()
                                            .sort((a, b) =>
                                              `${a.first_name} ${a.last_name}`.localeCompare(
                                                `${b.first_name} ${b.last_name}`
                                              )
                                            )
                                            .map((admin) => (
                                              <option
                                                key={admin.id}
                                                value={admin.id}
                                              >
                                                {admin.first_name}{' '}
                                                {admin.last_name}
                                              </option>
                                            ))}
                                      </Form.Control>
                                      <Form.Control.Feedback type="invalid">
                                        Please select an approver.
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              ))}
                            </div>
                          ))
                      ) : (
                        <div
                          className="text-center p-4"
                          style={{ marginTop: '20px' }}
                        >
                          No Records Found
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </div>
              </div>
            )}
            {activeClient && activeClient.enable_leave_credits === true && (
              <div
                className="border rounded d-flex"
                style={{
                  marginTop: '2rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                  marginBottom: '1rem',
                }}
              >
                <div
                  style={{
                    minWidth: '15rem',
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                  className="border-right"
                >
                  <strong>Leaves</strong>
                  <p className="pt-2 text-muted">
                    Assign leave credits and designate leave approvers.
                  </p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <Card className="mb-4">
                    <CardHeader className="d-flex justify-content-between align-items-center">
                      <strong>Leave Summary</strong>
                      <div className="d-flex">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            setShowUpdateDatesModal(true);
                          }}
                          className="btn btn-outline-secondary rounded me-2 adjust-fs adjust-shadow"
                          style={{ width: '200px' }}
                        >
                          Update Active Dates
                        </button>
                        <button
                          onClick={(e) => handleAddNewLeaveType(e)}
                          className="btn btn-brand rounded me-2 adjust-fs adjust-shadow"
                          style={{ width: '200px' }}
                        >
                          Add New
                        </button>
                      </div>
                    </CardHeader>

                    <CardBody>
                      <div className="table-responsive rounded shadow bg-white">
                        <Box sx={{ width: '100%' }}>
                          <DataGrid
                            columns={leaveColumns}
                            rows={data || []}
                            rowCount={totalRows || 1}
                            loading={loadingLeave}
                            pageSizeOptions={[10, 20, 30, 40, 50, 80, 100]}
                            paginationModel={paginationModel}
                            paginationMode="server"
                            onPaginationModelChange={(newPaginationModel) => {
                              setPaginationModel(newPaginationModel);
                              fetchLeave(newPaginationModel, sortModel);
                            }}
                            sortModel={sortModel}
                            sortingMode="server"
                            onSortModelChange={(newSortModel) => {
                              setSortModel(newSortModel);
                              fetchLeave(paginationModel, newSortModel);
                            }}
                            disableSelectionOnClick
                            isRowSelectable={() => false}
                            getRowId={(row) => row.id}
                          />
                        </Box>
                      </div>
                    </CardBody>
                  </Card>
                  <Card className="mb-4">
                    <CardHeader>
                      <strong>Approvers</strong>
                    </CardHeader>
                    <CardBody>
                      {leaveApprovers && leaveApprovers.length > 0 ? (
                        <div className="mb-4 p-3 border rounded col-md-8">
                          {/* Client Name as Title */}

                          {leaveApprovers.map((approver, index) => (
                            <div
                              key={approver.id}
                              className="row align-items-center mb-2"
                            >
                              {/* Approver Label */}
                              <div className="col-md-3 fw-bold">
                                Approver {index + 1}
                              </div>

                              {/* Capitalized Label Column */}
                              <div className="col-md-4">
                                {approver.value.charAt(0).toUpperCase() +
                                  approver.value.slice(1)}
                              </div>

                              {/* Dropdown Column */}
                              <div className="col-md-5">
                                <select
                                  className="form-select"
                                  value={
                                    selectedLeaveApprovers[
                                      approver.id
                                    ]?.source_id?.toString() || ''
                                  }
                                  onChange={(e) =>
                                    handleLeaveApproverChange(
                                      approver.id,
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Select</option>

                                  {/* Client Users */}
                                  {approver.value === 'client' &&
                                    filterApproversBySites(
                                      clientUsers,
                                      siteAssociates.map(
                                        (siteAssociate) => siteAssociate.site_id
                                      )
                                    ).map((user) => (
                                      <option key={user.id} value={user.id}>
                                        {user.first_name} {user.last_name}
                                      </option>
                                    ))}

                                  {/* Associates */}
                                  {approver.value === 'associate' &&
                                    associateList.length > 0 &&
                                    associateList.map((associate) => (
                                      <option
                                        key={associate.id}
                                        value={associate.id}
                                      >
                                        {associate.first_name}{' '}
                                        {associate.last_name}
                                      </option>
                                    ))}

                                  {/* Admins */}
                                  {approver.value === 'admin' &&
                                    filterApproversBySites(
                                      admins,
                                      siteAssociates.map(
                                        (siteAssociate) => siteAssociate.site_id
                                      )
                                    ).map((admin) => (
                                      <option key={admin.id} value={admin.id}>
                                        {admin.first_name} {admin.last_name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div
                          className="text-center p-4"
                          style={{ marginTop: '20px' }}
                        >
                          No Records Found
                        </div>
                      )}
                    </CardBody>
                  </Card>
                  <Card className="mb-4">
                    <CardHeader>
                      <strong>Rest Days</strong>
                    </CardHeader>
                    <CardBody>
                      <div className="mb-4 p-3 border rounded col-md-12">
                        <div className="row">
                          <div className="col-sm-12">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th className="border-bottom-0">Day</th>
                                  <th className="border-bottom-0 text-center">
                                    Monday
                                  </th>
                                  <th className="border-bottom-0 text-center">
                                    Tuesday
                                  </th>
                                  <th className="border-bottom-0 text-center">
                                    Wednesday
                                  </th>
                                  <th className="border-bottom-0 text-center">
                                    Thursday
                                  </th>
                                  <th className="border-bottom-0 text-center">
                                    Friday
                                  </th>
                                  <th className="border-bottom-0 text-center">
                                    Saturday
                                  </th>
                                  <th className="border-bottom-0 text-center">
                                    Sunday
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style={{ whiteSpace: 'nowrap' }}>
                                    <strong>Rest Days</strong>
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      value="Mon"
                                      checked={restDays.includes('Mon')}
                                      onChange={(e) =>
                                        handleRestDayChange('Mon', e)
                                      }
                                      className="ms-1 form-check-input position-static"
                                    />
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      value="Tue"
                                      checked={restDays.includes('Tue')}
                                      onChange={(e) =>
                                        handleRestDayChange('Tue', e)
                                      }
                                      className="ms-1 form-check-input position-static"
                                    />
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      value="Wed"
                                      checked={restDays.includes('Wed')}
                                      onChange={(e) =>
                                        handleRestDayChange('Wed', e)
                                      }
                                      className="ms-1 form-check-input position-static"
                                    />
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      value="Thu"
                                      checked={restDays.includes('Thu')}
                                      onChange={(e) =>
                                        handleRestDayChange('Thu', e)
                                      }
                                      className="ms-1 form-check-input position-static"
                                    />
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      value="Fri"
                                      checked={restDays.includes('Fri')}
                                      onChange={(e) =>
                                        handleRestDayChange('Fri', e)
                                      }
                                      className="ms-1 form-check-input position-static"
                                    />
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      value="Sat"
                                      checked={restDays.includes('Sat')}
                                      onChange={(e) =>
                                        handleRestDayChange('Sat', e)
                                      }
                                      className="ms-1 form-check-input position-static"
                                    />
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      value="Sun"
                                      checked={restDays.includes('Sun')}
                                      onChange={(e) =>
                                        handleRestDayChange('Sun', e)
                                      }
                                      className="ms-1 form-check-input position-static"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '6rem',
              }}
            >
              <div
                style={{
                  minWidth: '15rem',
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
              >
                <strong>Additional Info</strong>
                <p className="pt-2 text-muted">Manage additional details</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Row className="mb-3  pb-4">
                  <Form.Group as={Col} md="6">
                    <strong>Preferred Language</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      name="language"
                      onChange={(e) => languageHandler(e)}
                      value={language}
                    >
                      <option value="">Select Language</option>
                      <option value="en">English</option>
                      <option value="chi">Mandarin (普通)</option>
                    </Form.Control>
                  </Form.Group>
                </Row>

                <Row className="mb-3" style={{ justifyContent: 'flex-end' }}>
                  <button
                    type="button"
                    className="btn btn-success ms-3 adjust-fs adjust-shadow"
                    style={{ width: '9rem' }}
                    onClick={() => addMoreRoles()}
                  >
                    <i
                      className="fas fa-plus"
                      style={{
                        paddingRight: '0.5rem',
                      }}
                    ></i>
                    Add Roles
                  </button>
                </Row>

                {multipleRoles.length > 0 &&
                  multipleRoles.map(
                    (item, index) =>
                      !item.is_deleted && (
                        <Row className="mb-3" key={index}>
                          <Form.Group as={Col} md="6">
                            <strong>Position</strong>
                            <Form.Control
                              as="select"
                              type="select"
                              name="position"
                              onChange={(e) => positionHandler(e, index)}
                              value={item.role}
                            >
                              <option value="">Select Position</option>
                              {positionList &&
                                positionList.map((positionItem) => (
                                  <option
                                    key={positionItem.value}
                                    value={positionItem.value}
                                  >
                                    {positionItem.label}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                          <Form.Group as={Col} md="4">
                            <strong>PB JO No.</strong>
                            <Form.Control
                              value={item.pb_jo_no || ''}
                              placeholder="PB Job Order No."
                              onChange={(e) => positionPBJONOHandler(e, index)}
                              maxLength={10}
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="2"
                            style={{
                              justifyContent: 'center',
                              alignSelf: 'center',
                            }}
                          >
                            <span
                              className="text-danger"
                              style={{ cursor: 'pointer' }}
                              onClick={() => removeRoles(index)}
                            >
                              Remove
                            </span>
                          </Form.Group>
                        </Row>
                      )
                  )}
              </div>
            </div>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                backgroundColor: '#f3f3f3',
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={discardHandler}
                className="btn btn-outline-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </Form>
          <Modal showModal={showLeaveSummaryModal}>
            <div className="h-100">
              <form
                className="d-flex flex-column justify-content-between flex-grow-1 h-100"
                onSubmit={handleLeaveSubmit} // Fixed: removed arrow function
              >
                {/* Header with X button */}
                <div className="mb-4 d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 fw-semibold text-dark">
                    Manage Leave Credit
                  </h5>
                  <button
                    type="button"
                    onClick={handleCloseLeaveSummaryModal} // Fixed: removed arrow function
                    className="btn-close"
                    aria-label="Close"
                  ></button>
                </div>

                {/* Form Body */}
                <div className="flex-grow-1">
                  {/* Leave Type Selection */}
                  <div className="row mb-4 g-3">
                    <div className="col-4">
                      <label
                        htmlFor="leaveType"
                        className="form-label fw-medium mb-2"
                      >
                        Leave Type <span className="text-danger">*</span>
                      </label>
                      {modalMode === 'add' && (
                        <select
                          id="leaveType"
                          className="form-select adjust-fs"
                          value={leaveTypeId}
                          onChange={(e) => setLeaveTypeId(e.target.value)}
                          required
                        >
                          <option value="">Select Leave Type</option>
                          {filteredLeaveTypes.map((leave) => (
                            <option key={leave.id} value={leave.id}>
                              {leave.name}
                            </option>
                          ))}
                        </select>
                      )}
                      {modalMode === 'edit' && (
                        <div className="mt-2">
                          <span className="form-control-plaintext fw-light">
                            {leaveTypeName}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Leave Allocation Section */}
                  <div className="mb-4">
                    <div className="row g-3">
                      <div className="col-4">
                        <label
                          htmlFor="maxPerYear"
                          className="form-label fw-medium mb-2"
                        >
                          Max Per Year
                        </label>
                        <input
                          type="number"
                          className="form-control adjust-fs"
                          id="maxPerYear"
                          value={maxLeaves}
                          onChange={(e) => setMaxLeaves(e.target.value)}
                          min="0"
                          step="0.5"
                          placeholder="0"
                        />
                      </div>
                      <div className="col-4">
                        <label
                          htmlFor="available"
                          className="form-label fw-medium mb-2"
                        >
                          Available
                        </label>
                        <input
                          type="number"
                          className="form-control adjust-fs"
                          id="available"
                          value={available}
                          onChange={(e) => setAvailable(e.target.value)}
                          min="0"
                          step="0.5"
                          placeholder="0"
                        />
                      </div>
                      <div className="col-4">
                        <label
                          htmlFor="taken"
                          className="form-label fw-medium mb-2"
                        >
                          Taken
                        </label>
                        <input
                          type="number"
                          className="form-control adjust-fs"
                          id="taken"
                          value={taken}
                          onChange={(e) => setTaken(e.target.value)}
                          min="0"
                          step="0.5"
                          placeholder="0"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Active Period Section */}
                  <div className="mb-4">
                    <div className="row g-3">
                      <div className="col-4">
                        <label
                          htmlFor="activeFrom"
                          className="form-label fw-medium mb-2"
                        >
                          Active From <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          id="activeFrom"
                          className="form-control adjust-fs"
                          value={activeDate}
                          onChange={(e) => setActiveDate(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-4">
                        <label
                          htmlFor="activeTo"
                          className="form-label fw-medium mb-2"
                        >
                          Active To <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          id="activeTo"
                          className="form-control adjust-fs"
                          value={expiryDate}
                          onChange={(e) => setExpiryDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer Actions */}
                <div className="d-flex justify-content-end mt-auto pt-3 border-top">
                  <button
                    type="submit"
                    className="btn btn-brand adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </Modal>
          <Modal
            showModal={showUpdateDatesModal}
            customStyle={{
              border: '0',
              borderRadius: '20px',
              bottom: 'auto',
              height: '300px', // smaller height
              left: '50%',
              padding: '2rem',
              position: 'fixed',
              right: 'auto',
              top: '50%',
              transform: 'translate(-50%, -150px)', // half of height for centering
              width: '400px', // smaller fixed width
              maxWidth: '90vw', // responsive max width
            }}
          >
            <div className="h-100">
              <form
                className="d-flex flex-column justify-content-between flex-grow-1 h-100"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleBulkUpdateDates();
                }}
              >
                {/* Header */}
                <div className="mb-4 d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 fw-semibold text-dark">
                    Update Active Dates
                  </h5>
                  <button
                    type="button"
                    onClick={() => setShowUpdateDatesModal(false)}
                    className="btn-close"
                    aria-label="Close"
                  ></button>
                </div>

                {/* Form Body */}
                <div className="flex-grow-1">
                  <div className="row g-3">
                    <div className="col-6">
                      <label
                        htmlFor="bulkActiveFrom"
                        className="form-label fw-medium mb-2"
                      >
                        Active From <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        id="bulkActiveFrom"
                        className="form-control adjust-fs"
                        value={bulkActiveFrom}
                        onChange={(e) => setBulkActiveFrom(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="bulkActiveTo"
                        className="form-label fw-medium mb-2"
                      >
                        Active To <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        id="bulkActiveTo"
                        className="form-control adjust-fs"
                        value={bulkActiveTo}
                        onChange={(e) => setBulkActiveTo(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Footer Actions */}
                <div className="d-flex justify-content-end mt-auto pt-3 border-top">
                  <button
                    type="submit"
                    className="btn btn-brand adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </Modal>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddAssociate);
